export default {
  resolve(filters) {
    let selected = []
    for (let filter of filters) {
      let filterTitle = filter.title
      let selectedFilters = []
      for (let item of filter.items) {
        if (item.id !== 'all' && item.id !== 'none') {
          if (item.selected) {
            if (item.id) {
              selectedFilters.push(item.id)
            }
          }
        }
      }
      selected.push({filterGroup: filterTitle, selectedFilters: selectedFilters})
    }
    return selected
  }
}
